import { FunctionComponent, memo } from "react";
import Modal, { ModalContent, ModalHeader, useModal } from "@edgetier/modal";
import { Button } from "@edgetier/components";
import { faTimes, faTrash } from "@fortawesome/pro-solid-svg-icons";
import { IProps } from "./remove-tag-group-button.types";
import "./remove-tag-group-button.scss";

/**
 * Button with confirmation modal for removing all tags from a tag group
 * @param props.tagGroup
 * @param props.removeTagGroup
 */
const RemoveTagGroupButton: FunctionComponent<IProps> = ({ tagGroup, removeTagGroup }) => {
    const { closeModal, openModal, modalProps } = useModal();
    return (
        <>
            <Modal {...modalProps}>
                <ModalHeader>
                    <h2>Remove Tags</h2>
                </ModalHeader>
                <ModalContent>
                    <div className="remove-tag-group-button">
                        <p>Are you sure you want to remove all tags from "{tagGroup}" ?</p>
                    </div>
                    <div className="remove-tag-group-button__buttons">
                        <Button
                            icon={faTrash}
                            styleName="negative"
                            onClick={() => {
                                removeTagGroup(tagGroup);
                                closeModal();
                            }}
                        >
                            Remove Tags
                        </Button>
                    </div>
                </ModalContent>
            </Modal>
            <Button
                isIconOnly
                icon={faTimes}
                size="small"
                isUnstyled
                className="remove-tag-group-button__action"
                onClick={() => openModal()}
            />
        </>
    );
};

export default memo(RemoveTagGroupButton);
